import './BenefitsFootnote.css';const benefitsFootnote__paragraph = "_benefitsFootnote__paragraph_qavg5_1";
const styles = {
  benefitsFootnote__paragraph
};
export {
  benefitsFootnote__paragraph,
  styles as default
};
